import { Injectable, Injector, Optional } from '@angular/core';
import { NumberFormat, UserSettings } from '@farris/devkit';
import { FrmI18nSettingService } from '@gsp-sys/rtf-common';

@Injectable()
export class UserSettingsService implements UserSettings {
  constructor(private injector: Injector, @Optional() private frmI18nSettingService: FrmI18nSettingService) { }

  /**
   * ç¨æ·æ¶åºå­ç¬¦ä¸²
   */
  public get timeZone(): string {
    return this.timezone && this.timezone.id || null;
  }
  /**
   * æ¶åºåç§»
   */
  public get timeZoneOffset(): number {
    const offset = this.timezone && this.timezone.baseOffset;
    if (offset !== null && offset !== undefined) {
      return offset;
    } else {
      return null;
    }
  }
  /**
   * é»è®¤è¯­è¨
   */
  public get defaultLanguage(): string {
    return this.i18nSetting && this.i18nSetting.defaultLanguage || null;
  }
  /**
   * æ¥ææ ¼å¼åå­ç¬¦ä¸²
   * like: yyyy-MM-dd
   */
  public get dateFormat(): string {
    return this.i18nSetting && this.i18nSetting.userDateFormat || null;
  }
  /**
   * æ¶é´æ ¼å¼
   * like: HH:MM:ss
   */
  public get timeFormat(): string {
    return this.i18nSetting && this.i18nSetting.userTimeFormat || null;
  }
  public get dateTimeFormat(): string {
    const dateFormat = this.i18nSetting && this.i18nSetting.userDateFormat || 'yyyy-MM-dd';
    const timeFormat = this.i18nSetting && this.i18nSetting.userTimeFormat || 'HH:mm:ss';
    return `${dateFormat} ${timeFormat}`;
  }
  /**
   * å°åæ ¼å¼
   */
  public get addressFormat(): any {
    return null;
  }
  /**
   * æ°å­æ ¼å¼
   */
  public get numberFormat(): NumberFormat {
    if (this.i18nSetting && this.i18nSetting.userNumberFormat) {
      const userNumberFormat = this.i18nSetting.userNumberFormat;
      const numberFormat: NumberFormat = {
        negativeSign: userNumberFormat.negativeSign || '-',
        numberDecimalDigits: userNumberFormat.numberDecimalDigits || 2,
        numberDecimalSeparator: userNumberFormat.numberDecimalSeparator || '.',
        numberGroupSeparator: userNumberFormat.numberGroupSeparator || ','
      };
      return numberFormat;
    }
    return null;
  }
  /**
   * åºåä»£ç 
   */
  public get regionCode(): string {
    return this.i18nSetting && this.i18nSetting.userRegionCode || null;
  }
  /**
   * ç¨æ·éç½®
   */
  private get userSettings(): any {
    const userSettings = this.frmI18nSettingService && this.frmI18nSettingService.getSetting();
    return userSettings;
  }
  private get timezone() {
    return this.i18nSetting && this.i18nSetting.timezone;
  }
  private get i18nSetting() {
    return this.userSettings && this.userSettings.i18nSetting;
  }
}